import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, Header } from 'semantic-ui-react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import Fetch from '@/hooks/fetch';
import DataManagementPanelContainer from './DataManagementPanelContainer';
import DataManagementPanelHeader from './DataManagementPanelHeader';
import DataManagementDataModelTable from './DataManagementDataModelTable';
import DataManagementDictionariesTable from './DataManagementDictionariesTable';
import ValidateDataResultsPanel from './ValidateDataResultsPanel';
import UnmanagedDataMessage from './UnmanagedDataMessage';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import DatasetEvents from '../../hooks/events';

const DataManagementPanelFull = ({
  category,
  code,
  onChange,
  url,
}) => {
  const intl = useIntl();
  const {
    canRead,
    dictionaries,
    exists,
    hasDataModel,
    readErrors,
    readStatus,
    unmanagedData,
    unmanagedDataReasons,
    validationReadErrors,
  } = Selectors.useDataManagementPanel(category, code);
  const hideServerErrors = Events.useHideValidationServerErrors(category, { code });
  const fetchData = DatasetEvents.useFetchDataset('dataManagement', { code });
  Fetch.useFetchByCode(fetchData, 'dataManagement', code, readStatus);
  const showResultsPanel = () => !unmanagedData && dictionaries.length > 0;

  return (
    <DataManagementPanelContainer
      canRead={canRead}
      category={category}
      code={code}
      exists={exists}
      readErrors={readErrors}
      readStatus={readStatus}
    >
      <div className="aridhia-dataset-data-management-panel-full">
        <EntitiesErrorMessages
          category={category}
          code={code}
          contexts={['dictionaryUUID', 'fieldUUID']}
          entity="data-management"
          errors={validationReadErrors}
          onDismiss={(errors) => hideServerErrors({ errors })}
        />
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column>
              <DataManagementPanelHeader code={code} onChange={onChange} url={url} />
            </Grid.Column>
          </Grid.Row>
          {unmanagedData && (
            <Grid.Row columns="equal">
              <Grid.Column>
                <UnmanagedDataMessage reasons={unmanagedDataReasons} />
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
        {hasDataModel && (
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <DataManagementDataModelTable category={category} code={code} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Header as="h4">{intl.formatMessage({ id: 'dataset.dictionary.validation.table.heading' })}</Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <DataManagementDictionariesTable category={category} code={code} dictionaries={dictionaries} />
            </Grid.Column>
            <Grid.Column>
              {showResultsPanel() && <ValidateDataResultsPanel category={category} code={code} />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </DataManagementPanelContainer>
  );
};

export default DataManagementPanelFull;
